import { HStack, Spacer } from '@chakra-ui/react';
import { Button } from '@chakra-ui/button';
import React from 'react';

export interface CtaFilterButtonsProps {
  handleCancel: () => void;
  handleFilterChange: () => void;
  size: string;
}

export const CtaFilterButtons = (props: CtaFilterButtonsProps): JSX.Element => {
  const { handleCancel, handleFilterChange, size } = props;
  return (
    <HStack width={'100%'}>
      <Button size={size} colorScheme={'blue'} variant={'ghost'} onClick={handleCancel}>
        Abbrechen
      </Button>
      <Spacer />
      <Button size={size} colorScheme={'blue'} variant={'solid'} onClick={handleFilterChange}>
        Übernehmen
      </Button>
    </HStack>
  );
};
